export const UPDATE = "app/UPDATE";
export const SET_SLUG = "app/SET_SLUG";
export const LOADING = "app/LOADING";
export const SET_MANIFEST = "app/SET_MANIFEST";
export const SHOW_ALERT = "app/SHOW_ALERT";
export const HIDE_ALERT = "app/HIDE_ALERT";
